import { Link } from "react-router-dom";
import { categoryMap } from "@/mocks/articles";

export default function CategoryGrid() {
  const categories = [
    {
      key: "social",
      image: "https://readdy.ai/api/search-image?query=Abstract%20urban%20cityscape%20with%20warm%20amber%20evening%20light%2C%20people%20silhouettes%2C%20society%20life%20theme%2C%20editorial%20documentary%20style%2C%20soft%20atmospheric%20light%2C%20clean%20composition%2C%20warm%20golden%20tones&width=600&height=600&seq=cat-social-2026&orientation=squarish",
      gradient: "from-accent-500/60 via-accent-700/40 to-accent-900/80",
    },
    {
      key: "entertainment",
      image: "https://readdy.ai/api/search-image?query=Abstract%20stage%20performance%20with%20dramatic%20golden%20spotlights%2C%20entertainment%20and%20celebrity%20theme%2C%20warm%20amber%20tones%2C%20glamorous%20atmosphere%2C%20soft%20bokeh%20effects%2C%20editorial%20photography%20style%2C%20clean%20artistic%20composition&width=600&height=600&seq=cat-entertain-2026&orientation=squarish",
      gradient: "from-primary-500/60 via-primary-700/40 to-primary-900/80",
    },
    {
      key: "tech",
      image: "https://readdy.ai/api/search-image?query=Abstract%20futuristic%20technology%20circuit%20patterns%20with%20warm%20copper%20and%20gold%20tones%2C%20digital%20innovation%20theme%2C%20clean%20minimal%20design%2C%20soft%20atmospheric%20lighting%2C%20professional%20tech%20aesthetic%2C%20sleek%20composition&width=600&height=600&seq=cat-tech-2026&orientation=squarish",
      gradient: "from-secondary-500/60 via-secondary-700/40 to-secondary-900/80",
    },
  ];

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 mb-5">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-grid-line text-accent-600 text-xs"></i>
            </span>
            <span className="text-xs font-medium text-accent-700 tracking-wide">热点分类</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            探索你感兴趣的<span className="text-primary-600">爆料</span>
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            三大板块覆盖社会热点、娱乐八卦和科技前沿，总有你想看的
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((cat) => {
            const info = categoryMap[cat.key];
            return (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className="group relative aspect-square rounded-2xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform duration-300"
              >
                <img
                  src={cat.image}
                  alt={`${info.name}爆料 - 51黑料网`}
                  title={`${info.name} - 51黑料网`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className={`absolute inset-0 bg-gradient-to-b ${cat.gradient}`}></div>
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
                  <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mb-4">
                    <i className={`${info.icon} text-3xl md:text-4xl`}></i>
                  </span>
                  <h3 className="text-xl md:text-2xl font-heading font-bold">{info.name}</h3>
                  <p className="mt-2 text-sm text-white/70 text-center">
                    最新{info.name}内幕爆料
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}